import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SDS_SIZES } from '../types';
import { guardedCustomElement } from '../utils/guarded-custom-element';
import { styles } from './sds-tag.styles';

type TagSize = Extract<SDS_SIZES, 'lg' | 'md' | 'sm'>;

export interface SDSTagProps {
	size?: TagSize;
}

@guardedCustomElement('sds-tag')
export class SDSTag extends LitElement {
	static override styles = [styles];

	@property({ type: String, reflect: true }) size: TagSize = 'md';

	override render() {
		const tagClasses = {
			'sds-tag': true,
		};

		return html`<span class="${classMap(tagClasses)}">
			<slot></slot>
		</span>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'sds-tag': SDSTag;
	}
}
